import { Button, Icon, Modal } from '@successmode-ktp/kui';
import styled from 'styled-components';
import IMG_CLOSE from '@/assets/uploadFile/img_upload_close.png';
import IMG_BLURRY from '@/assets/uploadFile/img_upload_blurry.png';
import IMG_BRIGHT from '@/assets/uploadFile/img_upload_bright.png';
import IMG_DARK from '@/assets/uploadFile/img_upload_dark.png';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onClick: () => void;
};

const GuideModal = ({ isOpen, onClose, onClick }: Props) => {
  return (
    <Modal isOpen={isOpen} hasBackdrop>
      <Modal.Header>
        <HeaderContent>
          <Title>Upload Guide</Title>
          <CloseButton onClick={onClose}>
            <Icon.X fillColor='#5F6165' size={24} />
          </CloseButton>
        </HeaderContent>
      </Modal.Header>
      <ModalBody>
        <InstructionText>
          <p>Show all content clearly.</p>
          <p>Avoid too close, too far, bright, or dark photos.</p>
        </InstructionText>
        <ImageGrid>
          <ImageExample>
            <ImageBox>
              <Img src={IMG_CLOSE} alt='' />
            </ImageBox>
            <ImageLabel>
              <ErrorText>X </ErrorText>
              <LabelText>Too Close</LabelText>
            </ImageLabel>
          </ImageExample>
          <ImageExample>
            <ImageBox>
              <Img src={IMG_BLURRY} alt='' />
            </ImageBox>
            <ImageLabel>
              <ErrorText>X </ErrorText>
              <LabelText>Blurry Photo</LabelText>
            </ImageLabel>
          </ImageExample>
          <ImageExample>
            <ImageBox>
              <Img src={IMG_BRIGHT} alt='' />
            </ImageBox>
            <ImageLabel>
              <ErrorText>X </ErrorText>
              <LabelText>Bright Light</LabelText>
            </ImageLabel>
          </ImageExample>
          <ImageExample>
            <ImageBox>
              <Img src={IMG_DARK} alt='' />
            </ImageBox>
            <ImageLabel>
              <ErrorText>X</ErrorText>
              <LabelText>Low Light</LabelText>
            </ImageLabel>
          </ImageExample>
        </ImageGrid>
      </ModalBody>
      <Modal.Footer>
        <ConfirmButton type='button' onClick={onClick}>
          Confirm
        </ConfirmButton>
      </Modal.Footer>
    </Modal>
  );
};

export default GuideModal;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const Title = styled.h2`
  color: #030303;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: -0.48px;
  margin: 0;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  width: 100%;
  padding: 24px 0;
`;

const InstructionText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  color: #5f6165;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.26px;

  p {
    margin: 0;
  }
`;

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 13px 12px;
  width: 100%;
`;

const ImageExample = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const ImageBox = styled.div`
  width: 100%;
  aspect-ratio: 1;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
`;

const Img = styled.img`
  width: 142px;
  height: 142px;
`;

const ImageLabel = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: -0.28px;
`;

const ErrorText = styled.span`
  color: #ed0828;
  font-weight: 400;
`;

const LabelText = styled.span`
  color: #5f6165;
  font-weight: 400;
`;

const ConfirmButton = styled(Button)`
  width: 100%;
  background-color: #246cf6;
  color: white;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: -0.28px;
  padding: 14px 24px;
  border-radius: 8px;
  border: none;

  &:hover {
    opacity: 0.9;
  }
`;
